import { render, staticRenderFns } from "./ModuleInvoice.vue?vue&type=template&id=64181c34&"
import script from "./ModuleInvoice.js?vue&type=script&lang=js&"
export * from "./ModuleInvoice.js?vue&type=script&lang=js&"
import style0 from "./ModuleInvoice.vue?vue&type=style&index=0&id=64181c34&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports